import { t } from "@lingui/core/macro";
import { setLocale } from "yup";

export const setYupLocale = (i18n) => {
  setLocale({
    number: {
      required: t({ id: "yup.required", message: "Feld wird benötigt" }),
      typeError: t({ id: "yup.required", message: "Feld wird benötigt" }),
    },
    mixed: {
      required: t({ id: "yup.required", message: "Feld wird benötigt" }),
      typeError: t({ id: "yup.required", message: "Feld wird benötigt" }),
    },
    string: {
      email: t({ id: "yup.email", message: "Email ist ungültig" }),
    },
  });
};
